import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  useEffect(() => {
    const ref = localStorage.getItem("khm_ref");
    if (!user || !ref || user.role === "owner") return;
    localStorage.removeItem("khm_ref");
    api.post("/referrals/claim", { code: ref }).then(({ data }) => { if (data.ok) toast.success(`Invite accepted${data.inviter ? ` from ${data.inviter}` : ""} — you'll get bonus credits on your first pack.`); }).catch(() => {});
  }, [user]);

  return <AuthCtx.Provider value={{ user, setUser, logout, check }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
